module.exports = __webpack_public_path__ + "static/media/icono-energia.0bb317d6.svg";